var map = {
	"./childlabor1": [
		232,
		0
	],
	"./childlabor1.js": [
		232,
		0
	],
	"./childlabor2": [
		233,
		1
	],
	"./childlabor2.js": [
		233,
		1
	],
	"./childlabor3": [
		234,
		2
	],
	"./childlabor3.js": [
		234,
		2
	],
	"./earlymarriage1": [
		235,
		3
	],
	"./earlymarriage1.js": [
		235,
		3
	],
	"./earlymarriage2": [
		236,
		4
	],
	"./earlymarriage2.js": [
		236,
		4
	],
	"./earlymarriage3": [
		237,
		5
	],
	"./earlymarriage3.js": [
		237,
		5
	],
	"./education1": [
		238,
		6
	],
	"./education1.js": [
		238,
		6
	],
	"./education2": [
		239,
		7
	],
	"./education2.js": [
		239,
		7
	],
	"./education3": [
		240,
		8
	],
	"./education3.js": [
		240,
		8
	],
	"./healthcare1": [
		241,
		9
	],
	"./healthcare1.js": [
		241,
		9
	],
	"./healthcare2": [
		242,
		10
	],
	"./healthcare2.js": [
		242,
		10
	],
	"./healthcare3": [
		243,
		11
	],
	"./healthcare3.js": [
		243,
		11
	],
	"./prostitution1": [
		244,
		12
	],
	"./prostitution1.js": [
		244,
		12
	],
	"./prostitution2": [
		245,
		13
	],
	"./prostitution2.js": [
		245,
		13
	],
	"./prostitution3": [
		246,
		14
	],
	"./prostitution3.js": [
		246,
		14
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 398;
module.exports = webpackAsyncContext;